import { v4 as uuidv4 } from "uuid";

export function getDeviceId() {
  let deviceId = localStorage.getItem("device_id");
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem("device_id", deviceId);
  }
  return deviceId;
}

export function getDeviceName() {
  return `${navigator.platform || 'Web'} - ${navigator.userAgent.slice(0, 80)}`;
}